"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "displayName", {
  enumerable: true,
  get: function get() {
    return _identifiers.CTA_AREA;
  }
});
Object.defineProperty(exports, "identifier", {
  enumerable: true,
  get: function get() {
    return _identifiers.CTA_AREA;
  }
});
Object.defineProperty(exports, "theme", {
  enumerable: true,
  get: function get() {
    return _normal["default"];
  }
});
exports["default"] = void 0;

var _identifiers = require("../identifiers");

var _factory = _interopRequireDefault(require("./factory"));

var _reactCssThemr = require("react-css-themr");

var _normal = _interopRequireDefault(require("./_normal.scss"));

var _Text = _interopRequireDefault(require("./../Text"));

var _Button = _interopRequireDefault(require("./../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var factoryParams = {
  identifier: _identifiers.CTA_AREA,
  Text: _Text["default"],
  Button: _Button["default"]
};
var CtaArea = (0, _factory["default"])(factoryParams);
var themed = (0, _reactCssThemr.themr)(_identifiers.CTA_AREA, _normal["default"])(CtaArea);
/** @component */

var _default = themed;
exports["default"] = _default;